// extracted by mini-css-extract-plugin
module.exports = {"reviewsRatings":"ReviewsRatings_reviewsRatings__hJDeD","title":"ReviewsRatings_title__ea8tc","pr-reviewdisplay":"ReviewsRatings_pr-reviewdisplay__EZy91"};